import axiosInstance from '@/core/api'
import { components } from '@/schema'

export type ExportOverallAnalyticsCsvRequest =
	components['schemas']['GetOverallAnalyticsCsvDto']

export type ExportTransactionSummaryCsvRequest =
	components['schemas']['GetTransactionSummaryCsvDto']

export class AnalyticsExportService {
	static async exportOverallAnalyticsCsv(
		params: ExportOverallAnalyticsCsvRequest,
	): Promise<void> {
		const response = await axiosInstance.post(
			'/admin/analytics/overall-csv',
			params,
			{
				responseType: 'blob',
			},
		)

		const blob = new Blob([response.data], { type: 'text/csv' })
		const url = window.URL.createObjectURL(blob)
		const link = document.createElement('a')
		link.href = url
		link.download = `${params.filename || 'overall-analytics'}.csv`
		document.body.appendChild(link)
		link.click()
		document.body.removeChild(link)
		window.URL.revokeObjectURL(url)
	}

	static async exportTransactionSummaryCsv(
		params: ExportTransactionSummaryCsvRequest,
	): Promise<void> {
		const response = await axiosInstance.post(
			'/admin/analytics/transaction-summary-csv',
			params,
			{
				responseType: 'blob',
			},
		)

		const blob = new Blob([response.data], { type: 'text/csv' })
		const url = window.URL.createObjectURL(blob)
		const link = document.createElement('a')
		link.href = url
		link.download = `${params.filename || 'transaction-summary'}.csv`
		document.body.appendChild(link)
		link.click()
		document.body.removeChild(link)
		window.URL.revokeObjectURL(url)
	}
}
